import { isQualidocJwt } from '@/lib/auth/qualidoc-jwt';
import { AUTH_TOKEN_KEY } from '@/lib/constants';
import { atom } from 'jotai';
import Cookies from 'js-cookie';

export function checkIsLoggedIn() {
  return isQualidocJwt(Cookies.get(AUTH_TOKEN_KEY));
}
export const authorizationAtom = atom(checkIsLoggedIn());

